import * as Config from '@/Config';
import Store from '@/Store';
import ChalkySticks from '@chalkysticks/sdk';

/**
 * @param Record<string, any> options
 * @return Model.Venue
 */
export function model(options: Record<string, any> = {}): ChalkySticks.Model.Venue {
	const model = ChalkySticks.Factory.Venue.model(options);

	return model;
}

/**
 * * @param Record<string, any> options
 * @return Collection.Venue
 */
export function collection(options: Record<string, any> = {}): ChalkySticks.Collection.Venue {
	const collection = ChalkySticks.Factory.Venue.collection(options);
	const latitude = Store.getters['location/latitude'] || Config.App.DEFAULT_LATITUDE;
	const longitude = Store.getters['location/longitude'] || Config.App.DEFAULT_LONGITUDE;

	collection.setQueryParams({
		latitude,
		longitude,
	});

	return collection;
}
